import React from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";
import DashboardKpiCard from "../../../components/dashboard/DashboardKpiCard";
import { getComparisonText } from "./ordersDashboardFormatters";

const KpiCard = ({ icon, label, value, comparison }) => (
    <DashboardKpiCard
        icon={icon}
        label={label}
        value={value}
        comparison={comparison}
        comparisonFormatter={getComparisonText}
        comparisonLabel={i18n.translate("orders_dashboard_vs_previous_period")}
    />
);

KpiCard.propTypes = {
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    comparison: PropTypes.object
};

KpiCard.defaultProps = {
    comparison: null
};

export default KpiCard;
